<template>
  <div class="download-menu">
    <div class="download-menu__wrapper">
      <DsButton
        icon="icon"
        name="download"
        color="secondary"
        data-testid="toggle-download-menu"
        @click="handleToggleMenu"
      />

      <div
        class="download-menu__wrapper-list"
        :class="{ active: toggleMenu }"
      >
        <ul>
          <li
            v-for="item in downloadList"
            :key="item.type"
            class="download-menu__menu-item"
          >
            <button @click="handleDownload(item.type)">
              Baixar em {{ item.label.toUpperCase() }}
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { DsButton } from '@ds/components';
import { dispatchMixpanelTrack } from '@/utils';

export default {
  name: 'DownloadMenu',
  components: {
    DsButton,
  },
  props: {
    downloadList: {
      type: Array,
      default() {
        return [
          { label: 'PNG', type: 'png' },
          { label: 'PDF', type: 'pdf' },
          { label: 'CSV', type: 'csv' },
          { label: 'XLS', type: 'xls' },
        ];
      },
    },
    trackNameOnOpen: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      toggleMenu: false,
    };
  },
  watch: {
    toggleMenu(newValue) {
      if (newValue) {
        return document.addEventListener('click', this.handleClickOutside);
      }

      document.removeEventListener('click', this.handleClickOutside);
    },
  },
  methods: {
    handleDispatchTrackMenuOnOpen() {
      const isMenuOpen = this.toggleMenu;

      if (!isMenuOpen) return;

      dispatchMixpanelTrack(this.trackNameOnOpen, ['network', 'tab', 'groups']);
    },
    handleToggleMenu() {
      this.toggleMenu = !this.toggleMenu;

      this.handleDispatchTrackMenuOnOpen();
    },
    closeMenu() {
      this.toggleMenu = false;
    },
    emitSelectDownload({ typeSelected, action, isDownloadFunction }) {
      this.$emit('selectDownload', {
        typeSelected,
        action,
        isDownloadFunction,
      });
    },
    handleDownload(type) {
      const exportTypes = {
        png: 'image/png',
        pdf: 'application/pdf',
        csv: 'downloadCSV',
        xls: 'downloadXLS',
      };

      const typeExportSelected = exportTypes[type];

      if (!typeExportSelected) {
        this.emitSelectDownload({
          typeSelected: type,
          action: undefined,
          isDownloadFunction: false,
        });

        return;
      }

      const isDownloadFunction = [
        exportTypes.xls,
        exportTypes.csv,
      ].includes(typeExportSelected);

      this.emitSelectDownload({
        typeSelected: type,
        action: typeExportSelected,
        isDownloadFunction,
      });

      this.closeMenu();
    },
    handleClickOutside(e) {
      if (!this.$el.contains(e.target)) {
        this.closeMenu();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.download-menu {
  &__wrapper {
    position: relative;
  }

  &__wrapper-list {
    position: absolute;
    right: 0;
    top: 48px;
    width: max-content;
    padding: var(--ds-spacing-inset-quark);
    border-radius: var(--ds-border-radius-sm);
    border: 1px solid var(--ds-color-gray-3);
    box-shadow: 0 1px 12px -2px #00000014, 0 1px 8px -4px #00000029;
    opacity: 0;
    pointer-events: none;
    z-index: var(--zindex-100);
    transition: all 0.2s ease-in-out;
    background: var(--ds-color-white);

    ul {
      list-style: none;
      padding: 0;
    }

    &.active {
      opacity: 1;
      pointer-events: inherit;
    }
  }

  &__menu-item {
    font-size: var(--ds-font-size-baseline);
    border-radius: var(--ds-border-radius-sm);
    text-align: center;

    &:hover {
      background-color: #f5f5f5;
    }

    &:active {
      color: var(--ds-color-interactive);
      background: var(--ds-color-white);
    }

    button {
      width: 100%;
      padding: var(--ds-spacing-stack-nano) var(--ds-spacing-stack-xs);
    }
  }
}
</style>
